import { SessionHelper } from "app/helpers/sessionHelper";

import LanguageSelect from "app/components/LanguageSelector/LanguageSelect";
import { SessionType, UserType } from "app/types/userType";
import { OddsType, ResponsiveScreenSizesInt } from "app/utils/const";
import type { IntlShape } from "react-intl";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import PreferencesOddsSelector from "./components/PreferencesOddsSelector/PreferencesOddsSelector";
import "./Preferences.scss";
import "./PreferencesMobile.scss";
type Props = {
  loadUser: (...args: Array<any>) => any;
  intl: IntlShape;
  onLanguageChangeRequest: Function;
  session: SessionType;
  storedUserAccountDetails: UserType;
};

const Preferences: React.FC<Props> = props => {
  const { onLanguageChangeRequest, session } = props;
  const isMobile = window.innerWidth <= ResponsiveScreenSizesInt.mobile;

  return (
    <div className="preferences__component">
      {/* Asian view already has a language selector in the navbar so don't show in Preferences in asian view */}
      {(!SessionHelper.isAsianRouteAndSessionView() || isMobile) && (
        <LanguageSelect
          onLanguageChangeRequest={onLanguageChangeRequest}
          locale={session.language}
        />
      )}
      {/* component for handling logic and displaying odds type selecting */}
      <PreferencesOddsSelector
        OddsType={OddsType}
        account={props.storedUserAccountDetails}
        intl={props.intl}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  session: state.sessionModel.session,
  storedUserAccountDetails: state.userModel.user,
});

const mapDispatchToProps = (dispatch: any) => ({
  loadUser: () => {
    dispatch.userModel.loadUser();
  },
  onLanguageChangeRequest: (lang: string) => {
    dispatch.profileModel.onLanguageChange(lang);
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(Preferences)) as any;
